import { useTranslation } from 'react-i18next';
import { getNormalizedFeedbackGateState } from '../../utils/instrumentResponsePresentation';

function NormalizedResponseFeedbackGate({ assessment, children, provisionalProtocols = [] }) {
  const { t } = useTranslation();

  const gateState = getNormalizedFeedbackGateState(assessment, { provisionalProtocols });
  if (gateState.enabled) return children;

  return (
    <div className="warning-message" role="status">
      {t('normalized_response_feedback_unavailable')}
    </div>
  );
}

export default NormalizedResponseFeedbackGate;
